import React from "react";
import { Select, Option } from "informed";

export default ({ label, options, ...rest }) => {
  return (
    <div className="field">
      <label className="label">{label}</label>
      <div className="control">
        <div className="is-fullwidth select">
          <Select {...rest}>
            {options.map(({ label, value }) => {
              return (
                <Option key={value} value={value}>
                  {label}
                </Option>
              );
            })};
          </Select>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/form-fields/Select.js